<template>
    <div>
        <slot />
    </div>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery';

export default Vue.extend({
  name: 'botsplash-provider',

  data() {
    return {
      isWidgetLoaded: false,
      lastAuthState: null,
    };
  },

  mounted() {
    this.handleBotsplash();
    this.boundHandleClickEvent = this.handleClickEvent.bind(this);
    document.addEventListener('click', this.boundHandleClickEvent, true);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.boundHandleClickEvent, true);
  },
  methods: {
    handleClickEvent(event) {
      if (event.target.closest('.js-logout-btn')) {
        this.logoutBotsplash();
      }
    },

    async handleBotsplash() {
      try {
      const isLoggedIn = !!window.user;

      if (this.lastAuthState === isLoggedIn) return;
      this.lastAuthState = isLoggedIn;

      const tokenInfo = await this.generateBotsplashToken();

      if (isLoggedIn && !this.isWidgetLoaded) {
        if (!tokenInfo) {
            return;
        }
        window.BSPDASHBOARD_APP_URL = tokenInfo?.account_url;
        await this.loadBotsplashScript(tokenInfo);
        this.isWidgetLoaded = true;
      }

      if (!isLoggedIn && this.isWidgetLoaded) {
        this.isWidgetLoaded = false;
      }
     } catch (error) {
      console.error('Error handling Botsplash integration:', error);
     }
    },
    async loadBotsplashScript(tokenInfo) {
      try {
      const script = document.createElement('script');
      script.src = `${window.BSPDASHBOARD_APP_URL}/y.js`;
      script.async = true;

      script.onerror = () => {
        throw new Error('Failed to load Botsplash script');
      };

      script.onload = async () => {
       try {
        if (tokenInfo && window.$bspdashboard) {
          window.$bspdashboard.remove(true);
          await new Promise(r => setTimeout(r, 500)); 
             window.$bspdashboard.loginAccount(this.getAccountName(tokenInfo.account_url), tokenInfo.token, tokenInfo.account_url);
        }
       } catch (err) {
        console.error('Error during Botsplash login:', err);
       }
      };

      document.head.appendChild(script);
     } catch (error) {
      console.error('Error loading Botsplash script:', error);
     }
    },
    getAccountName(accountUrl) {
    if (accountUrl) {
      return accountUrl.split('//')[1].split('.')[0];
      }
      return null;
    },
    generateBotsplashToken() {
      return new Promise((resolve, reject) => {
        $.ajax({
          url: '/integration/botsplash-token',
          method: 'GET',
          global: false,
          crossDomain: true,
        })
         .done((data, textStatus, xhr) => {
            if (xhr.status === 204) {
            console.log('Botsplash permission is not granted for this user');
            } else {
            resolve(data);
            }
        })
        .fail(reject);
      });
    },
    async logoutBotsplash() {
      if (window.$bspdashboard && typeof window.$bspdashboard.logout === 'function') {
        try {
          window.$bspdashboard.logout();
        } catch (err) {
          console.error('Error logging out from Botsplash:', err);
        }
      }
    },
  },
});
</script>
